import React, {useEffect, useState} from 'react';
import ReactPaginate from 'react-paginate';
import {config} from "../../../../libs/config/config";


interface PaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (selectedItem: { selected: number }) => Promise<void>;
  onPageSizeChange: (newPageSize: number) => Promise<void>;
}

export const Pagination = (props: PaginationProps ) => {
  const {
    totalCount,
    pageSize,
    currentPage,
    onPageChange,
    onPageSizeChange,
  } = props;
  const [ pageCount, setPageCount ] = useState<number>(1);

  const handlePageSizeChange = async (value: number) => {
    await onPageSizeChange(value);
  }

  useEffect(() => {
    setPageCount(Math.max(Math.ceil( totalCount / pageSize), 1));
  }, [totalCount, pageSize]);

  return (
    <>
      <div className="flex text-primary text-xs font-semibold">
        <span className="pr-4 mr-4 border-r border-primary">Total : { totalCount }</span>
        <span className="pr-4 mr-3 border-r border-primary">
          <span>Number of Preview : </span>
          <select
            className="pagination-select"
            value={pageSize}
            onChange={e => {
              handlePageSizeChange(parseInt(e.target.value, 10));
            }}
          >
            {config.list.pageSizeOptions.map(pageSizeOption => (
              <option key={pageSizeOption} value={pageSizeOption}>
                {pageSizeOption}
              </option>
            ))}
          </select>
        </span>
        <ReactPaginate
          pageCount={pageCount}
          pageRangeDisplayed={4}
          marginPagesDisplayed={0}
          previousLabel="< PREV"
          nextLabel="NEXT >"
          breakLabel="..."
          containerClassName="inline-block flex"
          breakClassName="px-1"
          pageClassName="px-1"
          activeClassName="px-1 text-white bg-primary disabled"
          disabledClassName="px-1 opacity-50 disabled"
          onPageChange={onPageChange}
          // forcePageは0からスタート
          forcePage={currentPage - 1}
        />
      </div>

    </>
  );
};